import RecaptchaImport from 'react-google-recaptcha'
import { Button, Stack, type ButtonProps } from '@mui/material'
import { BYPASS_RECAPTCHA } from '../../settings'
import { useRecaptcha } from '../../utils/useRecaptcha'

const ReCAPTCHA =
  (RecaptchaImport as unknown as { default?: typeof RecaptchaImport })
    .default ?? RecaptchaImport

type FormSubmitWithRecaptchaProps = {
  submitLabel: string
  buttonProps?: ButtonProps
}

export function FormSubmitWithRecaptcha({
  submitLabel,
  buttonProps = {},
}: FormSubmitWithRecaptchaProps) {
  const { valid, validateCaptchaToken } = useRecaptcha()
  const { disabled: buttonDisabled, ...restButtonProps } = buttonProps

  return (
    <Stack alignItems="center" pt={4} gap={2}>
      {!BYPASS_RECAPTCHA && (
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY ?? ''}
          onChange={validateCaptchaToken}
        />
      )}
      <Button
        type="submit"
        variant="contained"
        disableElevation
        {...restButtonProps}
        disabled={!valid || Boolean(buttonDisabled)}
      >
        {submitLabel}
      </Button>
    </Stack>
  )
}
